<mat-card>
  <mat-card-title>Running Match</mat-card-title>
  <mat-progress-bar color="accent" class="primary-background"></mat-progress-bar>
  <mat-card-content fxLayout="row" fxLayout.xs="column">
    <div class="subbox" fxFlex="auto">
      <div class="digit">{{ "update.transplants" }}</div>
      <div class="caption">potential transplants</div>
    </div>
    <div class="subbox greyline" ngClass.xs="subbox" fxFlex="auto">
      <div class="digit">{{ "update.inspected" }}</div>
      <div class="caption">possible combinations</div>
    </div>
  </mat-card-content>
  <mat-card-actions fxLayout="row">
    <div fxFlex fxFlexFill></div>
    <button mat-button type="submit" color="primary">Cancel match</button>
  </mat-card-actions>
</mat-card>
